import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { CustomDimensionOutgoing } from '@kentik/ui-shared/types/customDimensions.types';
import { customDimensionsQuery } from 'app/stores/dictionary/raw/customDimensions';

export const useCustomDimensions = (): UseQueryResult<CustomDimensionOutgoing[], Error> =>
  useQuery(customDimensionsQuery);
